import {RoomClientState} from '../../../../shared/scripts/RoomClientState.ts'
import {UIMRoomPlayersController} from './UIMRoomPlayersController'
import {UIMRoomSettingsController} from './UIMRoomSettingsController'
import {uiManager} from '../../EntryMobile'
import {LobbyImage} from '@colonist/types'
import {TranslationObject} from '@colonist/i18n'
import {RoomTab, UIMFullscreenTabView} from './UIMFullscreenTabView'
import {RoomStep} from './UIMCreateRoomController'
import {createDiv} from '../../../../shared/scripts/ui_utils/DomUtils'
import {UIMInviteFriendsBottomDrawer} from '../../ui_popup/UIMInviteFriendsBottomDrawer'

enum RoomPageTabs {
    Settings,
    Players,
}
export class UIMRoomPageController {
    private readonly roomPageView: UIMFullscreenTabView
    private roomState: RoomClientState

    private roomSettingsController: UIMRoomSettingsController
    private roomPlayersController: UIMRoomPlayersController

    constructor(roomState: RoomClientState) {
        this.roomState = roomState

        const title: TranslationObject = {key: 'strings:roomPage.notifications.hash', options: {roomID: roomState.gameSetting.id}}
        const tabProperties: RoomTab[] = [
            {
                title: {key: 'strings:game.gearIcon.settings'},
                isActive: false,
                containerClass: 'm-room-settings-cards-container',
                id: RoomPageTabs.Settings,
            },
            {
                title: {key: 'strings:roomPage.notifications.playerCount', options: {
                    count: 1,
                    maxCount: 4,
                }},
                isActive: true,
                containerClass: 'm-room-players-main-container',
                id: RoomPageTabs.Players,
            },
        ]
        this.roomPageView = new UIMFullscreenTabView(title, tabProperties, undefined, (tabIdx: number) => {
            if(tabIdx != RoomPageTabs.Settings) return
            this.roomSettingsController.update(this.roomState) // Feb 23, 2024. Mau: Since the safe and warning slider zone percentage is based on the tick's position on the screen, we should recalculate it when switching tabs to prevent calculation errors on a hidden tab.
        })
        this.createAdElement()
        this.initializeControllers()
    }

    private createAdElement() {
        const adContainer = createDiv('banner_private_ad')
        this.roomPageView.body.prepend(adContainer)
        uiManager.adController.showLobbyVerticalAds()
    }

    private initializeControllers() {
        this.roomSettingsController = new UIMRoomSettingsController(this.roomPageView.getContainerWithTabIdx(RoomPageTabs.Settings),
            this.roomState,
            (idx: number) => uiManager.createRoomController.setShowPageOnNextUpdate(RoomStep.EditRoom, true, idx), true)
        this.roomPlayersController = new UIMRoomPlayersController(this.roomPageView.getContainerWithTabIdx(RoomPageTabs.Players), this.roomState)
    }

    update(roomState: RoomClientState) {
        this.roomState = roomState
        UIMInviteFriendsBottomDrawer.updateRoomState(roomState)
        const newHeader: TranslationObject = {key: 'strings:roomPage.notifications.hash', options: {roomID: roomState.gameSetting.id}}
        this.roomPageView.updateHeader(newHeader)

        const playerText: TranslationObject = {
            key: 'strings:roomPage.notifications.playerCount', options: {
                count: roomState.getSessionCount(),
                maxCount: roomState.gameSetting.maxPlayers,
            },
        }
        this.roomPageView.setTabTitle(RoomPageTabs.Players, playerText)

        this.roomSettingsController.update(roomState)
        this.roomPlayersController.update(roomState)
    }

    receivedChatMessage(avatar: LobbyImage, message: string, username?: string) {
        this.roomPlayersController?.chatController?.receivedChatMessage(avatar, message, username)
    }

    showView(tabIndex?: number) {
        this.roomPageView.show()
        if(tabIndex != undefined) this.roomPageView.updateActiveTabToIndex(tabIndex)
    }

    hideView() {
        this.roomPageView.updateActiveTabToIndex(RoomPageTabs.Players)
        this.roomPlayersController.chatController.clearMessages()
        this.roomPageView.hide()
    }
}
